/**
 *  firebase/index.js
 *  Ecoville
 *
 *  Last update by Bruno Bandeira on 17/01/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/storage';
import 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyBrGeGkaeKYaD8wqpWEDSGasrZRBWW2mkU",
    authDomain: "tookas-55a71.firebaseapp.com",
    databaseURL: "https://tookas-55a71.firebaseio.com",
    projectId: "tookas-55a71",
    storageBucket: "tookas-55a71.appspot.com",
    messagingSenderId: "492922329242",
    appId: "1:492922329242:web:33cc114009ed818db5a723",
    measurementId: "G-SYTMFX771K"
};

firebase.initializeApp(firebaseConfig);
export default firebase;